export default __webpack_public_path__ + "static/media/mochipay-circle-color.27c500c7.svg";